//TODO Sollte das Format des Identifiers matchen und andere Formate ausschließen

export const pattern = /[0-9]{6}/
